<app-strip-top-dev-environment></app-strip-top-dev-environment>
<app-menu></app-menu>
<router-outlet></router-outlet>
<app-toast-messages></app-toast-messages>
<app-footer></app-footer>